<!-- turno-landing.component.html -->
<div class="modal-container">
  <div class="modal-header">
    <h2 class="modal-title">Agendar Turno</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-stepper [linear]="isLinear" #stepper [disableRipple]="true">
    <!-- Paso 1: Identificación del paciente -->
    <mat-step [completed]="paso1Completado">
      <ng-template matStepLabel>Identificación del paciente</ng-template>

      <!-- HTML modificado para la sección de búsqueda/creación de paciente -->
      <form [formGroup]="formularioPaciente">
        <div class="form-section">
          <!-- Solo DNI para la búsqueda inicial -->
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{
              !agregarNuevoPaciente ? "Ingresar Nro Documento" : "Nro Documento"
            }}</mat-label>
            <input
              type="number"
              formControlName="dniPaciente"
              matInput
              [readonly]="
                pacienteSeleccionado ||
                loadingPacientePorDni ||
                agregarNuevoPaciente
              "
            />

            <span
              matSuffix
              *ngIf="loadingPacientePorDni"
              class="spinner-suffix"
            >
              <mat-spinner [diameter]="16"></mat-spinner>
            </span>
            <mat-error
              *ngIf="formularioPaciente.get('dniPaciente').hasError('required')"
            >
              El número de documento es requerido
            </mat-error>
          </mat-form-field>

          <button
            *ngIf="!pacienteSeleccionado && !agregarNuevoPaciente"
            mat-raised-button
            class="dniButton"
            color="primary"
            [disabled]="
              formularioPaciente.get('dniPaciente').hasError('required') ||
              loadingPacientePorDni
            "
            (click)="buscarPacientePorDni()"
          >
            Identificar Paciente
          </button>

          <!-- Mensaje cuando se encuentra un paciente -->
          <div *ngIf="pacienteSeleccionado" class="paciente-encontrado">
            <mat-card>
              <mat-card-content>
                <div class="paciente-info">
                  <p>
                    <strong>¡Bienvenido!:</strong>
                    {{ pacienteSeleccionado.name }} {{ pacienteSeleccionado.surname }}
                  </p>
                </div>

                <p>
                  <strong>Documento:</strong>
                  {{ pacienteSeleccionado.numeroDocumento }}
                </p>
                <p *ngIf="pacienteSeleccionado.email">
                  <strong>Email:</strong> {{ pacienteSeleccionado.email }}
                </p>
                <button
                  mat-raised-button
                  color="warn"
                  type="button"
                  (click)="deseleccionarPaciente()"
                >
                  Cancelar
                </button>
              </mat-card-content>
            </mat-card>
          </div>

          <!-- Campos adicionales para nuevo paciente (incluyendo tipo de documento) -->
          <div *ngIf="agregarNuevoPaciente" class="nuevo-paciente-form">
            <p>No pudimos identificarte: ¿Eres nuevo en la plataforma?</p>

            <p>Por favor completa los siguientes datos si deseas continuar:</p>
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Tipo documento</mat-label>
              <mat-select formControlName="tipoDniPaciente">
                <mat-option
                  *ngFor="let tipoDoc of tiposDocumentos"
                  [value]="tipoDoc?.id"
                >
                  {{ tipoDoc.texto }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="
                  formularioPaciente.get('tipoDniPaciente').hasError('required')
                "
              >
                El tipo de documento es requerido
              </mat-error>
            </mat-form-field>

            <div class="form-row">
              <mat-form-field appearance="fill">
                <mat-label>Nombre</mat-label>
                <input type="text" formControlName="nombrePaciente" matInput />
                <mat-error
                  *ngIf="
                    formularioPaciente
                      .get('nombrePaciente')
                      .hasError('required')
                  "
                >
                  El nombre es requerido
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="fill">
                <mat-label>Apellido</mat-label>
                <input
                  type="text"
                  formControlName="apellidoPaciente"
                  matInput
                />
                <mat-error
                  *ngIf="
                    formularioPaciente
                      .get('apellidoPaciente')
                      .hasError('required')
                  "
                >
                  El apellido es requerido
                </mat-error>
              </mat-form-field>
            </div>

            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Email</mat-label>
              <input type="email" formControlName="emailPaciente" matInput />
              <mat-error
                *ngIf="
                  formularioPaciente.get('emailPaciente').hasError('required')
                "
              >
                El email es requerido
              </mat-error>
              <mat-error
                *ngIf="
                  formularioPaciente.get('emailPaciente').hasError('email')
                "
              >
                Formato de email inválido
              </mat-error>
            </mat-form-field>

            <button
              mat-raised-button
              color="warn"
              type="button"
              (click)="cancelarNuevoPaciente()"
            >
              Cancelar
            </button>
          </div>
        </div>

        <div class="step-actions">
          <button
            mat-raised-button
            color="primary"
            (click)="avanzarAlPaso2()"
            [disabled]="
              !(
                pacienteSeleccionado ||
                (agregarNuevoPaciente && formularioPaciente.valid)
              )
            "
            matStepperNext
          >
            Continuar
          </button>
        </div>
      </form>
    </mat-step>

    <!-- Paso 2: Datos del turno -->
    <mat-step>
      <ng-template matStepLabel>Datos del turno</ng-template>

      <form [formGroup]="formularioTurno">
        <div class="form-section">
          <!-- Centro médico -->
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Centro médico</mat-label>
            <mat-select
              formControlName="centroMedico"
              [placeholder]="'Centro médico'"
              (ngModelChange)="validarCentroMedico($event)"
            >
              <mat-option>
                <ngx-mat-select-search
                  id="centroMedicoBuscador"
                  [noEntriesFoundLabel]="'Not found'"
                  [placeholderLabel]="'Buscador'"
                  formControlName="centroMedicoBuscador"
                  name="filterPost"
                  (ngModelChange)="filtrarCentroMedico()"
                >
                </ngx-mat-select-search>
              </mat-option>
              <mat-option [value]="0">
                <div class="optionCM">
                  <div class="nombreSelect">Elegir centro médico</div>
                </div>
              </mat-option>
              <mat-option
                *ngFor="let element of filtroCentroMedicos"
                [value]="element.id"
              >
                <div class="optionCM">
                  <div class="nombreSelect">{{ element.nombre }}</div>
                </div>
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                formularioTurno.get('centroMedico').errors?.required &&
                formularioTurno.get('centroMedico').touched
              "
            >
              El centro médico es requerido
            </mat-error>
          </mat-form-field>

          <!-- Especialidad -->
          <mat-form-field
            *ngIf="centroMedicoSeleccionado"
            appearance="fill"
            class="full-width"
          >
            <mat-label>Especialidad</mat-label>
            <mat-select
              formControlName="especialidad"
              [placeholder]="'Especialidad'"
              (ngModelChange)="filtrarEspecialidadMedico()"
            >
              <mat-option>
                <ngx-mat-select-search
                  id="especialidadBuscador"
                  [noEntriesFoundLabel]="'Not found'"
                  [placeholderLabel]="'Especialidad'"
                  formControlName="especialidadBuscador"
                  name="filterPost"
                  (ngModelChange)="filtrarEspecialidad()"
                >
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngIf="!requierePago" [value]="0">
                <div class="optionCM">
                  <div class="nombreSelect">Todas las especialidades</div>
                </div>
              </mat-option>
              <mat-option
                *ngFor="let element of filtroEspecialidades"
                [value]="element.id"
              >
                <div class="optionCM">
                  <div class="nombreSelect">{{ element.texto }}</div>
                </div>
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                requierePago &&
                formularioTurno.get('especialidad').errors?.especialidadRequerida &&
                formularioTurno.get('especialidad').touched
              "
            >
              La especialidad es requerida
            </mat-error>
          </mat-form-field>

          <!-- Servicio -->
          <mat-form-field
            *ngIf="mostrarServicioSelect"
            appearance="fill"
            class="full-width"
          >
            <mat-label>Servicio</mat-label>
            <mat-select
              formControlName="servicio"
              (ngModelChange)="seleccionarServicio($event)"
            >
              <mat-option *ngFor="let serv of listaServicios" [value]="serv.id">
                {{ serv.nombre }} ({{ serv.duracion }})
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Médico -->

          <mat-form-field
            *ngIf="centroMedicoSeleccionado"
            appearance="fill"
            class="full-width"
          >
            <mat-label>Médico</mat-label>
            <mat-select
              formControlName="id_medico"
              [placeholder]="'Médico'"
              (ngModelChange)="handleMedicoSeleccionado($event)"
            >
              <mat-option>
                <ngx-mat-select-search
                  id="medicoBuscador"
                  [noEntriesFoundLabel]="'Not found'"
                  [placeholderLabel]="'Buscador'"
                  formControlName="medicoBuscador"
                  name="filterPost"
                  (ngModelChange)="filtrarMedico()"
                >
                </ngx-mat-select-search>
              </mat-option>
              <mat-option
                *ngFor="let element of filtroMedicos"
                [value]="element.id"
              >
                <div class="optionCM">
                  <div class="nombreSelect">{{ element.nombreCompleto }}</div>
                </div>
              </mat-option>
            </mat-select>
            <mat-error
              style="color: rgba(229, 57, 53)"
              *ngIf="
                formularioTurno.get('id_medico').errors?.required &&
                formularioTurno.get('id_medico').touched
              "
            >
              El médico es requerido
            </mat-error>
          </mat-form-field>

          <!--Horarios Médico-->
          <div class="horarioMedico" *ngIf="medicoSelecionado && agendaActual">
            <span class="horario">Horario del médico</span>
            <div *ngIf="agendaActual.lunes_desde && agendaActual.lunes_hasta">
              Lunes {{ agendaActual.lunes_desde }} -
              {{ agendaActual.lunes_hasta }}
              <ng-container *ngIf="agendaActual.lunes_desde_2 && agendaActual.lunes_hasta_2">
                / {{ agendaActual.lunes_desde_2 }} - {{ agendaActual.lunes_hasta_2 }}
              </ng-container>
            </div>
            <div *ngIf="agendaActual.martes_desde && agendaActual.martes_hasta">
              Martes {{ agendaActual.martes_desde }} -
              {{ agendaActual.martes_hasta }}
              <ng-container *ngIf="agendaActual.martes_desde_2 && agendaActual.martes_hasta_2">
                / {{ agendaActual.martes_desde_2 }} - {{ agendaActual.martes_hasta_2 }}
              </ng-container>
            </div>
            <div
              *ngIf="
                agendaActual.miercoles_desde && agendaActual.miercoles_hasta
              "
            >
              Miercoles {{ agendaActual.miercoles_desde }} -
              {{ agendaActual.miercoles_hasta }}
              <ng-container *ngIf="agendaActual.miercoles_desde_2 && agendaActual.miercoles_hasta_2">
                / {{ agendaActual.miercoles_desde_2 }} - {{ agendaActual.miercoles_hasta_2 }}
              </ng-container>
            </div>
            <div *ngIf="agendaActual.jueves_desde && agendaActual.jueves_hasta">
              Jueves {{ agendaActual.jueves_desde }} -
              {{ agendaActual.jueves_hasta }}
              <ng-container *ngIf="agendaActual.jueves_desde_2 && agendaActual.jueves_hasta_2">
                / {{ agendaActual.jueves_desde_2 }} - {{ agendaActual.jueves_hasta_2 }}
              </ng-container>
            </div>
            <div
              *ngIf="agendaActual.viernes_desde && agendaActual.viernes_hasta"
            >
              Viernes {{ agendaActual.viernes_desde }} -
              {{ agendaActual.viernes_hasta }}
              <ng-container *ngIf="agendaActual.viernes_desde_2 && agendaActual.viernes_hasta_2">
                / {{ agendaActual.viernes_desde_2 }} - {{ agendaActual.viernes_hasta_2 }}
              </ng-container>
            </div>
            <div *ngIf="agendaActual.sabado_desde && agendaActual.sabado_hasta">
              Sabado {{ agendaActual.sabado_desde }} -
              {{ agendaActual.sabado_hasta }}
              <ng-container *ngIf="agendaActual.sabado_desde_2 && agendaActual.sabado_hasta_2">
                / {{ agendaActual.sabado_desde_2 }} - {{ agendaActual.sabado_hasta_2 }}
              </ng-container>
            </div>
            <div
              *ngIf="agendaActual.domingo_desde && agendaActual.domingo_hasta"
            >
              Domingo {{ agendaActual.domingo_desde }} -
              {{ agendaActual.domingo_hasta }}
              <ng-container *ngIf="agendaActual.domingo_desde_2 && agendaActual.domingo_hasta_2">
                / {{ agendaActual.domingo_desde_2 }} - {{ agendaActual.domingo_hasta_2 }}
              </ng-container>
            </div>
          </div>

          <!-- Fecha -->

          <mat-form-field
            appearance="fill"
            class="full-width"
            *ngIf="centroMedicoSeleccionado"
          >
            <mat-label>Fecha</mat-label>
            <input
              formControlName="fechaDesde"
              matInput
              [matDatepickerFilter]="boundedFiltrarFechasDatePicker"
              [matDatepicker]="fechaDesde"
              (ngModelChange)="cambiarTurno($event, 'fechaDesde')"
              [min]="diaActual"
              disabled
            />
            <mat-datepicker-toggle matSuffix [for]="fechaDesde">
            </mat-datepicker-toggle>
            <mat-datepicker
              #fechaDesde
              [disabled]="!medicoSelecionado"
            ></mat-datepicker>
            <mat-error
              *ngIf="
                formularioTurno.get('fechaDesde').errors?.required &&
                formularioTurno.get('fechaDesde').touched
              "
            >
              La fecha es requerida
            </mat-error>
          </mat-form-field>

          <!-- Horario -->
          <mat-form-field
            appearance="fill"
            class="full-width"
            *ngIf="centroMedicoSeleccionado"
          >
            <mat-label>Horarios</mat-label>
            <mat-select
              [disabled]="
                !medicoSelecionado || !formularioTurno.value.fechaDesde
              "
              (selectionChange)="seleccionarHorario($event)"
            >
              <ng-container *ngIf="medicoSelecionado">
                <mat-option
                  *ngFor="let turno of listaDeTurnosSinLosYaOtorgados()"
                  [value]="turno"
                >
                  {{ turno }}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="step-actions">
          <button mat-button matStepperPrevious>Atrás</button>
          <button
            mat-raised-button
            color="primary"
            (click)="guardarTurno()"
          >
            Solicitar turno
          </button>
        </div>
      </form>
    </mat-step>
  </mat-stepper>
</div>
